export function secondsToHms(seconds) {
    var h = Math.floor(seconds / 3600);
    var m = Math.floor((seconds % 3600) / 60);
    var s = Math.floor((seconds % 3600) % 60);
  
    var hDisplay = h < 10 ? `0${h}:` : `${h}:`;
    var mDisplay = m < 10 ? `0${m}:` : `${m}:`;
    var sDisplay = s < 10 ? `0${s}` : `${s}`;
    return hDisplay + mDisplay + sDisplay;
  }
  
export function hmsToSeconds(hms) {
    let hours = Number(hms.substring(0, 2));
    let minutes = Number(hms.substring(3, 5));
  
    let seconds = hours * 3600;
    seconds += minutes * 60;
  
    return seconds;
  }